export default "__VITE_ASSET__B8mrblc2__"